import Model from '@/store/model';
import AlliableFriends from './alliable_friends';
import Chatbot from './chatbot';
import StatusDetails from './status_details';
import RexLesson from './rex_lesson';

class Lessons extends Model {
  map(json) {
    super.map(json);
    if (json.alliable_friends !== undefined && json.alliable_friends !== null) {
      this.alliableFriends = new AlliableFriends();
      this.alliableFriends.map(json.alliable_friends);
    }
    if (json.chatbot !== undefined && json.chatbot !== null) {
      this.chatbot = new Chatbot();
      this.chatbot.map(json.chatbot);
    }
    if (json.status_details !== undefined && json.status_details !== null) {
      this.statusDetails = new StatusDetails();
      this.statusDetails.map(json.status_details);
    }
    if (json.rex_lesson !== undefined && json.rex_lesson !== null) {
      this.rexLesson = new RexLesson();
      this.rexLesson.map(json.rex_lesson);
    }
  }
}
export default Lessons;
